module.exports = __webpack_public_path__ + "static/media/art9.cd8c3c3d.png";